import Config from "../Config";
export const editorConfiguration = {
    toolbar: {
        items: [
            'undo', 'redo',
            '|',
            'sourceEditing',
            '|',
            'exportPdf', 'exportWord', 'importWord',
            '|',
            'formatPainter', 'findAndReplace', 'selectAll', 'wproofreader',
            '|',
            'heading',
            '|',
            'style',
            '|',
            'fontSize', 'fontFamily', 'fontColor', 'fontBackgroundColor',
            'bold', 'italic', 'underline',
            {
                label: 'Formatting',
                icon: 'text',
                items: ['strikethrough', 'subscript', 'superscript', 'code', '|', 'removeFormat']
            },
            '|',
            'specialCharacters', 'horizontalLine', 'pageBreak',
            '|',
            'link', 'ckbox', 'insertTable', 'tableOfContents', 'insertTemplate',
            '|',
            'highlight', 'blockQuote', 'mediaEmbed', 'uploadImage',
            '|',
            'alignment',
            '|',
             'bulletedList', 'numberedList', 'outdent', 'indent', 
        ],
        shouldNotGroupWhenFull: true
    },
    mediaEmbed: {
        previewsInData: true,
        removeProviders: [
            "instagram",
            "twitter",
            "googleMaps",
            "flickr",
            "facebook",
        ],

    },
    ckfinder: {
        uploadUrl: Config.apiUrl + "UserCompany/upload",
        //uploadUrl: "https://localhost:44389/api/UserCompany/upload",
    },

    style: {
        definitions: [
            {
                name: 'Article category',
                element: 'h3',
                classes: ['category']
            },
            {
                name: 'Title',
                element: 'h2',
                classes: ['document-title']
            },
            {
                name: 'Subtitle',
                element: 'h3',
                classes: ['document-subtitle']
            },
            {
                name: 'Info box',
                element: 'p',
                classes: ['info-box']
            },
            {
                name: 'Side quote',
                element: 'blockquote',
                classes: ['side-quote']
            },
            {
                name: 'Marker',
                element: 'span',
                classes: ['marker']
            },
            {
                name: 'Spoiler',
                element: 'span',
                classes: ['spoiler']
            },
            {
                name: 'Code (dark)',
                element: 'pre',
                classes: ['fancy-code', 'fancy-code-dark']
            },
            {
                name: 'Code (bright)',
                element: 'pre',
                classes: ['fancy-code', 'fancy-code-bright']
            }
        ]
    },

    fontFamily: {
        supportAllValues: true
    },
    fontSize: {
        options: [10, 12, 14, 'default', 18, 20, 22],
        supportAllValues: true
    },
    image: {
        resizeUnit: "%",
        // toolbar: [
        //   'imageTextAlternative', 'toggleImageCaption', '|',
        //   'imageStyle:inline', 'imageStyle:wrapText', 'imageStyle:breakText', 'imageStyle:side', '|',
        //   'resizeImage'
        // ],
        toolbar: [
            "imageStyle:full",
            "imageStyle:side",
            "imageStyle:alignLeft",
            "imageStyle:alignCenter",
            "imageStyle:alignRight",
            "|",
            "imageStyle:sideLeft",
            "|",
            "imageTextAlternative",

        ],
        styles: [
            'alignCenter',
            'alignLeft',
            'alignRight'
        ],
        resizeOptions: [
            {
                name: 'resizeImage:original',
                value: null,
                label: 'Original'
            },
            {
                name: 'resizeImage:40',
                value: '40',
                label: '40%'
            },
            {
                name: 'resizeImage:60',
                value: '60',
                label: '60%'
            }
        ],
    },
    list: {
        properties: {
            styles: true,
            startIndex: true,
            reversed: true
        }
    },
    link: {
        addTargetToExternalLinks: true
        // decorators: {
        //     openInNewTab: {
        //         mode: 'manual',
        //         label: 'Open in a new tab',
        //         defaultValue: true,         
        //         attributes: {
        //             target: '_blank',
        //             rel: 'noopener noreferrer'
        //         }
        //     }
        // }
    },
    table: {
        contentToolbar: [
            'tableColumn', 'tableRow', 'mergeTableCells',
            'tableProperties', 'tableCellProperties'
        ],
    },
}
